import React, { useEffect, useState } from "react";

export default function Footer() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const fmt = new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(now);
      setTime(fmt);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="relative overflow-hidden footer-orange" style={{ paddingTop: 70 }}>
      <div className="footer-noise" />

      <div className="container-x relative z-10">
        <div className="flex items-center justify-between gap-6 pb-12 border-b border-white/15 flex-wrap">
          <div className="flex items-center gap-3">
            <img
              src="/main-logo.png"
              alt="The LinkedIn Lab"
              className="rounded-xl object-contain"
              style={{ height: 48, width: "auto", display: "block" }}
            />
          </div>
          <div className="flex items-center gap-6 text-white/80 flex-wrap">
            <a href="/#services" className="hover:text-white transition text-sm">How It Works</a>
            <a href="/#results" className="hover:text-white transition text-sm">Results</a>
            <a href="/#pricing" className="hover:text-white transition text-sm">Pricing</a>
            <a href="/#about" className="hover:text-white transition text-sm">About</a>
            <a href="/blog" className="hover:text-white transition text-sm">Blog</a>
            <a
              href="https://thelinkedinlabreports.substack.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition text-sm inline-flex items-center gap-1"
            >
              Reports
            </a>
          </div>
          <div className="flex items-center gap-5">
            <a
              href="https://www.linkedin.com/company/agency-linkedin-lab-/"
              target="_blank"
              rel="noreferrer"
              className="hidden sm:inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-white text-sm transition"
              style={{ background: "rgba(255,255,255,0.10)", border: "1px solid rgba(255,255,255,0.14)" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zM8 19H5V8h3v11zM6.5 6.73c-.97 0-1.75-.79-1.75-1.76S5.53 3.2 6.5 3.2s1.75.79 1.75 1.77S7.47 6.73 6.5 6.73zM20 19h-3v-5.6c0-1.34-.02-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97V19h-3V8h2.88v1.5h.04c.4-.76 1.38-1.56 2.84-1.56 3.04 0 3.6 2 3.6 4.6V19z"/></svg>
              Follow LinkedIn Lab
            </a>
            <a
              href="#qualify"
              className="px-4 py-2 rounded-full text-white text-sm font-medium transition"
              style={{ background: "rgba(255,255,255,0.14)" }}
            >
              Send a note
            </a>
            <a
              href="#booking"
              className="px-4 py-2 rounded-full bg-white text-[#0A0A0A] text-sm font-medium hover:bg-neutral-100 transition"
            >
              Book a Call
            </a>
          </div>
        </div>

        <div className="flex items-center justify-between py-8 text-white/80 text-sm relative z-10 flex-wrap gap-4">
          <div>&copy; 2025 LinkedIn Lab. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span>Local time &rarr;</span>
            <span className="font-mono">{time}</span>
          </div>
          <button
            onClick={scrollTop}
            className="text-white hover:text-white/80 transition flex items-center gap-2"
          >
            Back to top &uarr;
          </button>
        </div>
      </div>

      <div className="relative z-0" style={{ marginTop: 24 }}>
        <div
          className="agero-mega text-center"
          style={{
            fontSize: "clamp(80px, 16vw, 280px)",
            lineHeight: 0.85,
            padding: "0 12px",
            letterSpacing: "-0.05em",
          }}
        >
          LinkedIn Lab
        </div>
      </div>
    </footer>
  );
}
